import dayjs from 'dayjs'

export function formatDatetimeToLocalTime(datetime: string): string {
  const moment = dayjs(datetime)
  const ltFormat = moment.format('LT')
  const is24HourFormat = ltFormat?.includes('H') ?? false
  return moment.format(is24HourFormat ? 'HH:mm' : 'hh:mm A')
}
